class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.boundClose = this.close.bind(this);
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.boundClose);
    this.querySelector('#close-popup-drawer')?.addEventListener('click', this.boundClose);
    this.setHeaderCartIconAccessibility();
    this.setupEventListeners();

    this.openCartFromUrl();
    
  }

    // New method to setup event listeners
  setupEventListeners() {
    // Use event delegation for overlay and close buttons
    this.addEventListener('click', (event) => {
      // Close when overlay is clicked
      if (event.target.id === 'CartDrawer-Overlay') {
        this.close();
      }
      
      // Close when close button is clicked
      if (event.target.closest('#close-popup-drawer') || 
          event.target.closest('.drawer__close')) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  openCartFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('cartOpen') === 'true' && !this.classList.contains('active')) {
      this.open();
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      if (!document.body.classList.contains('cross-sell-open')) {
        this.classList.add('animate', 'active');
       } 
      if (
        this.classList.contains('active')
      ) {
        console.log('Cart drawer is active and not empty');
        let currentUrl = new URL(window.location.href);
        console.log('Current URL:', currentUrl.href);
        currentUrl.searchParams.set('cartOpen', 'true');
        console.log('Updated URL:', currentUrl.href);
        window.history.replaceState({}, '', currentUrl);
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

   document.body.classList.add('overflow-m-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
   document.body.classList.remove('overflow-m-hidden');
    const url = new URL(window.location.href);
    url.searchParams.delete('cartOpen');
    window.history.replaceState({}, '', url);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      
    });

  

  // ✅ wait for DOM replacement to finish
  setTimeout(() => {
    const closeBtn = this.querySelector('#close-popup-drawer');
    if (closeBtn) {
      closeBtn.removeEventListener('click', this.boundClose);
      closeBtn.addEventListener('click', this.boundClose);
    }

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.removeEventListener('click', this.boundClose);
      overlay.addEventListener('click', this.boundClose);
    }

    this.open();
  }, 500);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
